import XLSX from "xlsx";


// تشخیص تاریخ شمسی برای جلوگیری از تبدیل اشتباه آن به عدد
const isJalaliDateLike = (value) => {
  return typeof value === "string" && /\d{4}\/\d{1,2}\/\d{1,2}/.test(value);
};

const convertToFloat = (data) => {

  const newArray = [...data]
  for (let i = 0; i < newArray.length; i++) {
    for (const index in newArray[i]) {
      let myString = newArray[i][index]
      if (typeof myString !== "string") continue;

      // اعداد منفی داخل پرانتز
      if (myString[0] === "(" && myString[myString?.length - 1] === ")") {
        const negative = myString.replaceAll("(", "").replaceAll(")", "").replaceAll(",", "")
        if (negative.trim() !== "" && !isNaN(parseFloat(negative))) {
          newArray[i][index] = parseFloat(negative) * (-1)
        }
        continue
      }

      // تاریخ‌ها و اعدادی که از قبل جداکننده هزارگان دارند را تبدیل نمی‌کنیم
      if (index.includes('تاریخ') || isJalaliDateLike(myString)) continue
      if (myString.includes(",")) continue

      const trimmed = myString.trim()
      if (/^-?\d+(\.\d+)?$/.test(trimmed)) {
        newArray[i][index] = parseFloat(trimmed)
      }
    }
  }
  return newArray
}
const convertToCSV1 = (objArray: string) => {
  const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  let str = "";

  for (let i = 0; i < array.length; i++) {
    let line = "";
    for (const index in array[i]) {
      if (line != "") line += ",";

      line += array[i][index];
    }

    str += line + "\r\n";
  }

  return str;
};
const convertToCSV = (objArray: string) => {
  const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  let str = "";

  for (let i = 0; i < array.length; i++) {
    let line = "";
    for (const index in array[i]) {
      if (line !== "") line += ",";
      // Format numbers as numbers, other values as strings
      const value = typeof array[i][index] === "number" ? array[i][index] : `"${array[i][index]}"`;
      line += value;
    }

    str += line + "\r\n";
  }

  return str;
};


const exportCSVFile = (
  data: { [key: string]: any }[],
  fileTitle: string,
  headers?: { [key: string]: string }[]
) => {
  const items = JSON.parse(JSON.stringify(data));
  if (headers) {
    items.unshift(headers);
  } else {
    let obj: { [key: string]: string } = {};
    Object.keys(items[0]).map((value) => {
      obj[value] = value;
    });

    items.unshift(obj);
  }

  // Convert Object to JSON
  const jsonObject = JSON.stringify(items);
  const exportedFileName = fileTitle + ".csv" || "export.csv";

  const utf8BOM = "\uFEFF";
  debugger
  const csvContent = convertToCSV(jsonObject);
  const blob = new Blob([utf8BOM, csvContent], {type: "text/csv;charset=utf-8;"});

  const link = document.createElement("a");
  if (link.download !== undefined) {
    // feature detection
    // Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", exportedFileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
export const exportXLSXFile = (
  data: { [key: string]: any }[],
  fileTitle: string,
  headers?: { [key: string]: string } | string,
  options: { priceFields?: string[] } = {}
) => {

  data = convertToFloat(data)

  const items = JSON.parse(JSON.stringify(data));
  const worksheet = XLSX.utils.json_to_sheet(items);

  // ترتیب ستون‌ها بر اساس کلیدهای داده
  const columns = [];
  items.forEach((row) => {
    Object.keys(row).forEach((key) => {
      if (!columns.includes(key)) columns.push(key);
    });
  });

  const range = worksheet["!ref"] ? XLSX.utils.decode_range(worksheet["!ref"]) : null;

  if (range) {
    // جایگزینی عنوان ستون‌ها با عنوان فارسی در صورت وجود
    if (headers && typeof headers === "object") {
      columns.forEach((key, index) => {
        if (index > range.e.c || !headers[key]) return;
        const headerCell = worksheet[XLSX.utils.encode_cell({ r: 0, c: index })];
        if (headerCell) headerCell.v = headers[key];
      });
    }

    // اعمال جداکننده هزارگان روی ستون‌های مبلغ
    const priceFields = Array.isArray(options.priceFields) ? options.priceFields : [];
    if (priceFields.length > 0) {
      columns.forEach((key, index) => {
        if (index > range.e.c || !priceFields.includes(key)) return;
        const column = XLSX.utils.encode_col(index);
        for (let row = 1; row <= range.e.r; row += 1) {
          const cell = worksheet[column + (row + 1)];
          if (cell && typeof cell.v === "number") {
            cell.z = "#,##0";
          }
        }
      });
    }
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, worksheet, "Sheet1");

  // Create a Blob with XLSX format
  const wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
  const blob = new Blob([wbout], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const exportedFileName = fileTitle + ".xlsx" || "export.xlsx";

  const link = document.createElement("a");
  if (link.download !== undefined) {
    // Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", exportedFileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export default exportCSVFile;
